import React, {Component} from 'react';
import CustomPaper from "../../../shared/utils/CustomPaper";
import {List, ListItem} from 'material-ui/List';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {IconMenu} from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import RaisedButton from 'material-ui/RaisedButton';
import ActionGrade from 'material-ui/svg-icons/action/grade';
import ActionDescription from 'material-ui/svg-icons/action/description';
import {blue200, pinkA200} from 'material-ui/styles/colors';
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import RichTextEditor from 'react-rte';
import Alert from "../../../shared/utils/Alert";
import EntrepriseService from "../services/EntrepriseService";
import {OffreDetails} from '../../../shared/utils/OfferDetails';
import {connect} from "react-redux"
import PostesDisponiblesSalarie from '../../../salarie/bodies/PostesDisponibles'


class PostesDisponibles extends Component {

    static LEFT_PANEL_VIEW = {
        NONE: 0,
        NEW_OFFER: 1,
        OFFER_DETAILS: 2,
        OFFER_EDIT: 3,
        CANDIDATURES: 4
    };

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            rightPanelView: PostesDisponibles.LEFT_PANEL_VIEW.NONE,
            selectedOffer: null,
            postes: [],
            intitule: '',
            localisation: '',
            type_contrat: '',
            descriptif: RichTextEditor.createEmptyValue()
        };

        this.entrepriseService = new EntrepriseService();
        this.handleChange = this.handleChange.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDeltePoste = this.handleDeltePoste.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.getAllPostes = this.getAllPostes.bind(this);
        this.showOffer = this.showOffer.bind(this);
        this.onShowCandidaturesClick = this.onShowCandidaturesClick.bind(this);
        this.showNewOfferForm = this.showNewOfferForm.bind(this);
    }

    onEditClick(o) {
        this.setState({
            rightPanelView: PostesDisponibles.LEFT_PANEL_VIEW.OFFER_EDIT,
            id: o.id,
            intitule: o.intitule,
            localisation: o.localisation,
            type_contrat: o.type_contrat,
            descriptif: RichTextEditor.createValueFromString(o.descriptif, 'html')
        })
    }

    componentDidMount() {
        this.getAllPostes();
    }

    getAllPostes() {
        this.entrepriseService.getEntreprisePostes()
            .then(x => this.setState({postes: x.data.payload}));
    }

    handleDeltePoste(o) {
        const x = window.confirm('Êtes-vou sûr de vouloir supprimer ?');
        if (x) {
            this.entrepriseService.deletePoste(o.id)
                .then(() => {
                    this.getAllPostes();
                    window.alert('Poste supprimé avec succès');
                    this.setState({selectedOffer: null, rightPanelView: PostesDisponibles.LEFT_PANEL_VIEW.OFFER_EDIT})
                });
        }

    }

    handleSubmit() {
        const html = this.state.descriptif.toString('html');
        this.entrepriseService.addNewPoste({
            edit: this.state.rightPanelView === PostesDisponibles.LEFT_PANEL_VIEW.OFFER_EDIT,
            id: this.state.id,
            intitule: this.state.intitule,
            localisation: this.state.localisation,
            type_contrat: this.state.type_contrat,
            descriptif: html,
        }).then(() => {
            this.getAllPostes();
            alert('Poste sauvegardé');
            this.setState({
                rightPanelView: PostesDisponibles.LEFT_PANEL_VIEW.NONE,
                intitule: '',
                localisation: '',
                type_contrat: '',
                date_publication: new Date(),
                descriptif: RichTextEditor.createEmptyValue()
            })
        });
    }

    showNewOfferForm() {
        this.setState({
            rightPanelView: PostesDisponibles.LEFT_PANEL_VIEW.NEW_OFFER
        });
    }

    onShowCandidaturesClick(o) {
        this.setState({
            rightPanelView: PostesDisponibles.LEFT_PANEL_VIEW.CANDIDATURES,
            selectedOffer: o
        });
    }

    showOffer(o) {
        this.setState({
            rightPanelView: PostesDisponibles.LEFT_PANEL_VIEW.OFFER_DETAILS,
            selectedOffer: o
        });
    }


    render() {
        const offer = this.state.selectedOffer;
        const toolbarConfig = {
            // Optionally specify the groups to display (displayed in the order listed).
            display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN'],
            INLINE_STYLE_BUTTONS: [
                {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
                {label: 'Italic', style: 'ITALIC'},
                {label: 'Underline', style: 'UNDERLINE'}
            ],
            BLOCK_TYPE_DROPDOWN: [
                {label: 'Normal', style: 'unstyled'},
                {label: 'Titre grand', style: 'header-one'},
                {label: 'Titre moyen', style: 'header-two'},
                {label: 'Titre petit', style: 'header-three'}
            ],
            BLOCK_TYPE_BUTTONS: [
                {label: 'UL', style: 'unordered-list-item'},
                {label: 'OL', style: 'ordered-list-item'}
            ]
        };
        return (
            <div className="row">
                <div className='col-4'>
                    <CustomPaper title={"Postes disponibles en interne"}>
                        <List>
                            <ListItem
                                primaryText="Ajouter un nouveau poste"
                                leftIcon={<ActionGrade color={pinkA200}/>}
                                onClick={this.showNewOfferForm}
                            />
                            <Divider inset={true}/>
                            {
                                this.state.postes.length > 0 &&
                                this.state.postes.map(o =>
                                    <ListItem
                                        key={o.id}
                                        primaryText={o.intitule}
                                        secondaryText={o.localisation + ' - ' + o.type_contrat}
                                        rightIconButton={
                                            <IconMenu iconButtonElement={
                                                <IconButton
                                                    touch={true}
                                                    tooltip="Plus"
                                                    tooltipPosition="bottom-left"
                                                >
                                                    <MoreVertIcon color={blue200}/>
                                                </IconButton>
                                            }
                                            >
                                                <MenuItem onClick={() => this.onEditClick(o)}>Modifier</MenuItem>
                                                <MenuItem onClick={() => this.onShowCandidaturesClick(o)}>Voir les
                                                    candidatures</MenuItem>
                                                <MenuItem onClick={() => this.handleDeltePoste(o)}>Supprimer</MenuItem>
                                            </IconMenu>
                                        }
                                        leftIcon={<ActionDescription color={blue200}/>}
                                        onClick={() => this.showOffer(o)}
                                    />
                                )
                            }
                        </List>

                    </CustomPaper>
                </div>
                <div className='col-8'>
                    {
                        (
                            this.state.rightPanelView === PostesDisponibles.LEFT_PANEL_VIEW.NEW_OFFER ||
                            this.state.rightPanelView === PostesDisponibles.LEFT_PANEL_VIEW.OFFER_EDIT
                        ) &&
                        <CustomPaper title={"Ajout d'un poste"}>
                            <ValidatorForm
                                ref="form"
                                onSubmit={this.handleSubmit}
                            >
                                <div className='row'>
                                    <div className='col'>
                                        <TextValidator
                                            floatingLabelText="Intitulé du poste"
                                            onChange={this.handleChange}
                                            name="intitule"
                                            value={this.state.intitule}
                                            validators={['required', 'trim']}
                                            errorMessages={['Ce champs est obligatoire', 'Nom invalide']}
                                        />
                                    </div>
                                    <div className='col'>
                                        <TextValidator
                                            floatingLabelText="Localisation"
                                            onChange={this.handleChange}
                                            name="localisation"
                                            value={this.state.localisation}
                                            validators={['required', 'trim']}
                                            errorMessages={['Ce champs est obligatoire', 'Nom invalide']}
                                        />
                                    </div>
                                </div>
                                <br/>
                                <TextValidator
                                    floatingLabelText="Type de contrat"
                                    onChange={this.handleChange}
                                    name="type_contrat"
                                    value={this.state.type_contrat}
                                    validators={['required', 'trim']}
                                    errorMessages={['Ce champs est obligatoire', 'Nom invalide']}
                                /><br/><br/>
                                <Alert text="Veuillez décrire le poste ci-dessous :"/>
                                <RichTextEditor
                                    editorStyle={{minHeight: 100}}
                                    toolbarConfig={toolbarConfig}
                                    name="descriptif"
                                    value={this.state.descriptif}
                                    onChange={this.handleEditorChange}
                                /><br/>
                                <RaisedButton
                                    label="Sauvegarder"
                                    primary={true}
                                    type='submit'
                                />
                            </ValidatorForm>
                        </CustomPaper>
                    }

                    {
                        this.state.selectedOffer && this.state.rightPanelView === PostesDisponibles.LEFT_PANEL_VIEW.OFFER_DETAILS &&
                        <OffreDetails
                            intitule={offer.intitule}
                            descriptif={offer.descriptif}
                            type_contrat={offer.type_contrat}
                            date_publication={offer.date_publication}
                            localisation={offer.localisation}
                        />
                    }
                    {
                        this.state.rightPanelView === PostesDisponibles.LEFT_PANEL_VIEW.CANDIDATURES &&
                        <Candidatures
                            offreID={offer.id}
                            offreIntitule={offer.intitule}
                        />
                    }
                </div>

            </div>
        );
    }

    handleChange(event, value) {
        let obj = {};
        obj[event.target.name] = value;
        this.setState(obj);
    }

    handleEditorChange(value) {
        this.setState({descriptif: value});
    }

}

function mapStateToProps(store) {
    return {entrepriseName: store.entreprise.entreprise_infos.nom}
}

export default connect(mapStateToProps)(PostesDisponibles);

class Candidatures extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            candidatures: []
        };
        this.entrepriseService = new EntrepriseService();
        this.accepterCandidature = this.accepterCandidature.bind(this);
    }

    getOfferCandidatures() {
        this.entrepriseService.getPosteCandidatures(this.props.offreID)
            .then(x => this.setState({candidatures: x.data.payload}));
    }

    componentDidMount() {
        this.getOfferCandidatures();
    }

    accepterCandidature(candidatureId, accept) {
        this.entrepriseService.acceptCandidature(candidatureId, accept)
            .then(() => this.getOfferCandidatures());
    }

    render() {
        return (
            <CustomPaper
                title={'Candidatures < ' + this.props.offreIntitule + ' >'}
            >
                {
                    this.state.candidatures.length > 0 ? this.state.candidatures.map(c =>
                        <div>
                            <label>Numéro de salarié: {c.num_salarie}</label><br/>
                            <label>Nom: {c.nom}</label><br/>
                            <label>Prénom: {c.prenom}</label><br/>
                            <label>Statut de la candidature: {PostesDisponiblesSalarie.parseEtat(c.status)}</label><br/>
                            <a onClick={() => this.accepterCandidature(c.id_candidature, 1)}
                               style={{color: 'green', cursor: 'pointer'}}
                               href="#//"
                            >Accepter</a><br/>
                            <a onClick={() => this.accepterCandidature(c.id_candidature, 2)}
                               style={{color: 'orange', cursor: 'pointer'}}
                               href="#//"
                            >Refuser</a><br/>
                            <Divider/>
                        </div>
                    ) : <Alert text={'Aucune candidature pour ce poste actuellement'}/>
                }

            </CustomPaper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entreprise/PostesDisponibles.js